import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import useCartData from "@/components/Cart/hooks/useCartData";
import useGNBHandler from "@/components/common/GNB/useGNBHandler";
import useLogout from "@/components/common/GNB/useLogout";
import { mixpanelEvent } from "@/lib/mixpanels/mixpanel";
import { cn } from "@/lib/utils";
import { LIBRARIES_INDEX_PAGE, SHOP_CART_PAGE, SOLVOOK_WRITE_STUDIO } from "@/settings/constant";
import { Badge, IconV2, Typography } from "@bookips/sds";
const GNBMenuButtons = (param)=>{
    let { className  } = param;
    const { handlePageMove  } = useGNBHandler();
    const { isLoggedIn  } = useLogout();
    const { cartCounts  } = useCartData(isLoggedIn);
    const handleExpertClick = ()=>{
        mixpanelEvent("GNB Button Clicked", {
            "Button Type": "엑스퍼트",
            "Button Name": "엑스퍼트",
            "Button URL": SOLVOOK_WRITE_STUDIO
        }, {
            send_immediately: true
        });
        handlePageMove(SOLVOOK_WRITE_STUDIO, false);
    };
    const handleLibraryClick = ()=>{
        handlePageMove(LIBRARIES_INDEX_PAGE, false);
    };
    const handleCartClick = ()=>{
        handlePageMove(SHOP_CART_PAGE, false);
    };
    return /*#__PURE__*/ _jsxs("div", {
        className: cn("flex items-center gap-1", className),
        children: [
            /*#__PURE__*/ _jsxs(GNBMenuButtonWrapper, {
                onClick: handleExpertClick,
                children: [
                    /*#__PURE__*/ _jsx(IconV2.Expert, {}),
                    /*#__PURE__*/ _jsx(Typography, {
                        variant: "label",
                        className: "max-lg:hidden",
                        children: "엑스퍼트"
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs(GNBMenuButtonWrapper, {
                onClick: handleLibraryClick,
                children: [
                    /*#__PURE__*/ _jsx(IconV2.OldLibrary, {}),
                    /*#__PURE__*/ _jsx(Typography, {
                        variant: "label",
                        className: "max-lg:hidden",
                        children: "자료 보관함"
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs(GNBMenuButtonWrapper, {
                onClick: handleCartClick,
                children: [
                    /*#__PURE__*/ _jsx(IconV2.Cart, {}),
                    /*#__PURE__*/ _jsx(Typography, {
                        variant: "label",
                        className: "max-lg:hidden",
                        children: "장바구니"
                    }),
                    (cartCounts === null || cartCounts === void 0 ? void 0 : cartCounts.total) > 0 && /*#__PURE__*/ _jsx(Badge, {
                        type: "count",
                        color: "red",
                        label: cartCounts.total > 99 ? "99+" : String(cartCounts.total),
                        className: "absolute -top-0.5 right-2.5"
                    })
                ]
            })
        ]
    });
};
export const GNBMenuButtonWrapper = (param)=>{
    let { children , onClick  } = param;
    return /*#__PURE__*/ _jsx("button", {
        type: "button",
        className: "relative flex min-h-[50px] min-w-[52px] flex-col items-center gap-0.5 rounded-md p-1 transition-colors hover:bg-gray-50",
        onClick: onClick,
        children: children
    });
};
export default GNBMenuButtons;
